import { Navigation } from "../navigation/navigation"
import { SelectLanguage } from "../select-language/select-language"
import { GiHamburgerMenu } from "react-icons/gi";

import "./header.scss";
import { createContext, useState } from "react";

export const HeaderContext = createContext<any|null>(null);

export function Header(){
    const [displayNav,setDisplayNav] = useState<any>(null);
    const [displaySelectLang,setDisplaySelectlang] = useState<any>(null);
    function displayNavigation(){
        setDisplayNav(!displayNav);
    }


    return(
        <>

        <div className="header-container">  
            <HeaderContext.Provider value={{displayNav,setDisplayNav,displaySelectLang,setDisplaySelectlang}}>
            <section className="section-container flex">
                <figure className="logo-container">
                    <img src="/logo.png" height='60' className='logo' title="les toiles de la Juine"/>
                </figure>
                <Navigation display={displayNav} setDisplay={setDisplayNav} />
                <SelectLanguage/>
           
                <div className="hide-desktop hamburger-container">
                  <GiHamburgerMenu onClick={()=>{displayNavigation()}} />
                </div>

            </section>
            </HeaderContext.Provider>
        </div>


        </>
    )
}